import React from 'react'
import { debounce } from 'shared/utils/debounce'

interface ISize {
  width: number
  height: number
}

const debounceFunc = debounce(
  (setWindowSize: React.Dispatch<React.SetStateAction<ISize>>) =>
    setWindowSize({ width: window.innerWidth, height: window.innerHeight }),
  500,
)

export default function useWindowSize() {
  const [windowSize, setWindowSize] = React.useState<ISize>({
    width: 1200,
    height: 800,
  })

  function changeWindowSize() {
    debounceFunc(setWindowSize)
  }

  React.useEffect(() => {
    setWindowSize({ width: window.innerWidth, height: window.innerHeight })
    window.addEventListener('resize', changeWindowSize)

    return () => {
      window.removeEventListener('resize', changeWindowSize)
    }
  }, [])

  return windowSize
}
